/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PaginationDto } from '../models/pagination-dto';
import { productControllerCopy } from '../fn/product/product-controller-copy';
import { ProductControllerCopy$Params } from '../fn/product/product-controller-copy';
import { productControllerCreate } from '../fn/product/product-controller-create';
import { ProductControllerCreate$Params } from '../fn/product/product-controller-create';
import { productControllerDelete } from '../fn/product/product-controller-delete';
import { ProductControllerDelete$Params } from '../fn/product/product-controller-delete';
import { productControllerFindAll } from '../fn/product/product-controller-find-all';
import { ProductControllerFindAll$Params } from '../fn/product/product-controller-find-all';
import { productControllerFindById } from '../fn/product/product-controller-find-by-id';
import { ProductControllerFindById$Params } from '../fn/product/product-controller-find-by-id';
import { productControllerSearch } from '../fn/product/product-controller-search';
import { ProductControllerSearch$Params } from '../fn/product/product-controller-search';
import { productControllerSetActive } from '../fn/product/product-controller-set-active';
import { ProductControllerSetActive$Params } from '../fn/product/product-controller-set-active';
import { productControllerUpdate } from '../fn/product/product-controller-update';
import { ProductControllerUpdate$Params } from '../fn/product/product-controller-update';
import { ProductDto } from '../models/product-dto';

@Injectable({ providedIn: 'root' })
export class ProductService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productControllerSearch()` */
  static readonly ProductControllerSearchPath = '/api/products/search';

  /**
   * [비회원, 회원] 상품 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch$Response(params: ProductControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return productControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * [비회원, 회원] 상품 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSearch(params: ProductControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.productControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `productControllerFindAll()` */
  static readonly ProductControllerFindAllPath = '/api/products';

  /**
   * 모든 Product 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindAll$Response(params?: ProductControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductDto>>> {
    return productControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Product 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindAll(params?: ProductControllerFindAll$Params, context?: HttpContext): Observable<Array<ProductDto>> {
    return this.productControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProductDto>>): Array<ProductDto> => r.body)
    );
  }

  /** Path part for operation `productControllerCreate()` */
  static readonly ProductControllerCreatePath = '/api/products';

  /**
   * Product 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate$Response(params: ProductControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Product 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerCreate(params: ProductControllerCreate$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerFindById()` */
  static readonly ProductControllerFindByIdPath = '/api/products/{id}';

  /**
   * Product id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById$Response(params: ProductControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * Product id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerFindById(params: ProductControllerFindById$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerCopy()` */
  static readonly ProductControllerCopyPath = '/api/products/{id}';

  /**
   * Product 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerCopy()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerCopy$Response(params: ProductControllerCopy$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerCopy(this.http, this.rootUrl, params, context);
  }

  /**
   * Product 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerCopy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerCopy(params: ProductControllerCopy$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerCopy$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerDelete()` */
  static readonly ProductControllerDeletePath = '/api/products/{id}';

  /**
   * Product 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete$Response(params: ProductControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return productControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Product 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerDelete(params: ProductControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.productControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `productControllerUpdate()` */
  static readonly ProductControllerUpdatePath = '/api/products/{id}';

  /**
   * Product 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate$Response(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Product 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productControllerUpdate(params: ProductControllerUpdate$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

  /** Path part for operation `productControllerSetActive()` */
  static readonly ProductControllerSetActivePath = '/api/products/{id}/visible';

  /**
   * Product 노출 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productControllerSetActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSetActive$Response(params: ProductControllerSetActive$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDto>> {
    return productControllerSetActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Product 노출 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productControllerSetActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productControllerSetActive(params: ProductControllerSetActive$Params, context?: HttpContext): Observable<ProductDto> {
    return this.productControllerSetActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductDto>): ProductDto => r.body)
    );
  }

}
